/**
 * i18n setup — react-i18next + browser-languagedetector
 *
 * Lingue supportate: it (default/source), en, es, fr, de
 * Persistenza: localStorage chiave 'orch_lang'
 * Detection: localStorage > query string ?lang=X > navigator.language > fallback IT
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import it from './locales/it.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import de from './locales/de.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      de: { translation: de },
    },
    fallbackLng: 'it',
    supportedLngs: ['it', 'en', 'es', 'fr', 'de'],
    nonExplicitSupportedLngs: true,  // 'it-IT' → 'it'
    detection: {
      order: ['localStorage', 'querystring', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'orch_lang',
      lookupQuerystring: 'lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
